import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { useLocation } from 'react-router';
import SVG from 'react-inlinesvg';
import { toAbsoluteUrl } from '../../../../_helpers';
import { SubMenu } from './SubMenu';

export const MenuOption = ({ item }) => {
	const location = useLocation();
	const { pathname } = location;
	const [isOpen, setIsOpen] = useState(false);

	const handleToggle = (e) => {
		if (item.submodules && item.submodules.length > 0) {
			e.preventDefault();
			setIsOpen(!isOpen);
		}
	};

	const isActive = pathname.includes(item.slug) || pathname === item.slug;

	return (
		<li className={`menu-item ${isOpen ? 'menu-item-open' : ''}`}>
			<NavLink
				className={`menu-link menu-toggle ${isActive ? 'activeItemMenu' : ''}`}
				to={item.slug}
				onClick={handleToggle}
			>
				<span className="svg-icon menu-icon">
					<SVG src={toAbsoluteUrl(`/media/svg/icons/${item.icon}`)} />
				</span>
				<span className="menu-text">{item.title}</span>
				{item.submodules && item.submodules.length > 0 && (
					<i className="menu-arrow" />
				)}
			</NavLink>

			{item.submodules && item.submodules.length > 0 && isOpen && (
				<SubMenu submenu={item.submodules} />
			)}
		</li>
	);
};
